export default __webpack_public_path__ + "static/media/tv.c35ced49.svg";